// Blog-specific URLs on the backend.

// Backend origin. Set NEXT_PUBLIC_API_BASE_URL at build time (e.g. https://api.hachion.co
// for the production build); unset keeps the test backend this checkout is wired to.
export const BLOG_API_ORIGIN = (process.env.NEXT_PUBLIC_API_BASE_URL || "https://api.hachion.co").replace(/\/+$/, "");

// Where blog images are served on that origin. Verified against both
// api.hachion.co and api.hachion.co: blog_image values such as
// "images/NLPUsecases_CI.webp" return 200 image/webp from /uploads/prod/blogs/<file>,
// while /uploads/prod/blogs/<file> returns 404 on both hosts.
export const BLOG_UPLOADS_PATH = "/uploads/prod/blogs";
export const BLOG_IMAGE_BASE = `${BLOG_API_ORIGIN}${BLOG_UPLOADS_PATH}`;

// Absolute URL of a file stored under the blog uploads folder (blog_image /
// authorImage are bare paths such as "images/x.webp"). Percent-encoded per
// segment because uploaded names contain spaces/parentheses, which crawlers
// reject or truncate when raw. Already-absolute values pass through; empty
// input gives "" so callers can fall back to a placeholder.
export function blogAssetUrl(file) {
  const value = typeof file === "string" ? file.trim() : "";
  if (!value) return "";
  if (/^https?:\/\//i.test(value)) return value;
  return `${BLOG_IMAGE_BASE}/${value.replace(/^\/+/, "").split("/").map(encodeURIComponent).join("/")}`;
}
